import { inject, provide } from 'vue';

import type { NTable } from '../interface';
import type { InjectionKey } from 'vue';

export type TSummaryFlattenColumns<RecordType> = readonly (NTable.NColumn.IColumn<RecordType> & {
  scrollbar?: boolean;
})[];

interface ISummaryContextProps {
  stickyOffsets?: NTable.NSticky.IStickyOffsets;
  scrollColumnIndex?: number | null;
  flattenColumns?: TSummaryFlattenColumns<any>;
}

export const SummaryContextKey: InjectionKey<ISummaryContextProps> = Symbol('cds:table:summary');

export const useProvideSummary = (props: ISummaryContextProps) => {
  provide(SummaryContextKey, props);
};

export const useInjectSummary = () => {
  return inject(SummaryContextKey, {} as ISummaryContextProps);
};
